export type TBillingAccountsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export const billingKeys = {
  all: [{ module: 'billing' }] as const,
  pendingTopUps: () => [{ ...billingKeys.all[0], scope: 'pendingTopUps' }] as const,
  pendingTopUpsByAccount: (baId: string) => [{ ...billingKeys.pendingTopUps()[0], baId }] as const,
  asOnePlans: () => [{ ...billingKeys.all[0], scope: 'asOnePlans' }] as const,
  allAsOnePlans: () => [{ ...billingKeys.asOnePlans()[0], visibility: 'all' }] as const,
  publishedAsOnePlans: () => [{ ...billingKeys.asOnePlans()[0], visibility: 'published' }] as const,
  adminAsOnePlans: () => [{ ...billingKeys.all[0], scope: 'adminAsOnePlans' }] as const,
  accounts: () => [{ ...billingKeys.all[0], scope: 'account' }] as const,
  account: (baId: string) => [{ ...billingKeys.accounts()[0], baId }] as const,
  memberAccount: (baId: string) => [{ ...billingKeys.accounts()[0], baId, access: 'member' }] as const,
  adminAccounts: () => [{ ...billingKeys.all[0], scope: 'adminAccount' }] as const,
  adminAccount: (baId: string) => [{ ...billingKeys.adminAccounts()[0], baId }] as const,
  paymentMethods: () => [{ ...billingKeys.all[0], scope: 'paymentMethods' }] as const,
  paymentMethodsByAccount: (baId: string) => [{ ...billingKeys.paymentMethods()[0], baId }] as const,
  memberPaymentMethodsByAccount: (baId: string) =>
    [{ ...billingKeys.paymentMethods()[0], baId, access: 'member' }] as const,
  transactions: () => [{ ...billingKeys.all[0], scope: 'transactions' }] as const,
  transactionsByAccount: (baId: string) => [{ ...billingKeys.transactions()[0], baId }] as const,
  memberTransactionsByAccount: (baId: string) =>
    [{ ...billingKeys.transactions()[0], baId, access: 'member' }] as const,
  accountLists: () => [{ ...billingKeys.all[0], scope: 'accountList' }] as const,
  accountList: (params: TBillingAccountsListParams) => [{ ...billingKeys.accountLists()[0], params }] as const,
};
